import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function StarFilledIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M18.1826 14.4697L23.6123 9.17725L16.1084 8.08692C15.7832 8.03956 15.501 7.83546 15.3555 7.54004L12 0.740234L8.64453 7.54003C8.49902 7.83544 8.2168 8.03954 7.8916 8.08691L0.387695 9.17725L5.81739 14.4697C6.05372 14.6992 6.16114 15.0303 6.10548 15.355L4.82325 22.8281L11.5342 19.2998C11.8252 19.1465 12.1738 19.1465 12.4648 19.2998L19.1768 22.8281L17.8945 15.355C17.8389 15.0303 17.9463 14.6992 18.1826 14.4697Z",
    fill: "currentColor"
  }));
}